import * as angular from 'angular';
import * as _ from 'underscore';
import { ICollectedAnalyticsData } from '../../analytics.service';

class AnalyticsChartComponent {
    public static $inject = ['$scope'];
    public timeFormat: string;
    public dataset: ICollectedAnalyticsData[];
    public filteredDataset: ICollectedAnalyticsData[];
    public tooltipFormat: string;
    public options = {
        grid: {
            hoverable: true,
            clickable: true,
            borderWidth: 0,
            color: '#8394a9'
        },
        legend: {
            show: false
        },
        tooltip: true,
        tooltipOpts: {
            content: this.tooltipFormat,
            xDateFormat: this.timeFormat
        },
        xaxis: {
            tickColor: '#f1f2f3',
            mode: 'time',
            timeformat: this.timeFormat,
            ticks: null as number
        },
        yaxis: {
            min: 0,
            minTickSize: 1,
            tickDecimals: 0,
            tickFormatter: (number) => {
                return number.toString();
            }
        },
        shadowSize: 0,
        series: {
            lines: {
                show: true
            },
            points: {
                show: true,
                radius: 4
            }
        },
        colors:  ['#e6194b',	'#3cb44b',	'#ffe119',	'#0082c8',	'#f58231',		'#911eb4', '#000000',		'#f032e6',	'#d2f53c',	'#fabebe',	'#008080',	'#e6beff',
        '#aa6e28', '#fffac8',	'#800000', '#aaffc3', '#808000', '#ffd8b1',	'#000080',	'#808080', '#000000', '#46f0f0'	]
    };

    constructor(
        protected $scope: ng.IScope
    ) {
        $scope.$watch('vm.dataset', (dataset: ICollectedAnalyticsData[]) => {
            if (dataset) {
                const numberOfItems = dataset[0].data.length;
                this.options.series.points.show = numberOfItems <= 20;
                this.options.tooltipOpts.xDateFormat = this.options.xaxis.timeformat = this.timeFormat;
                this.options.xaxis.ticks = Math.min(10, numberOfItems);
                this.dataset = dataset;

                for (let i = 0; i < dataset.length; i++) {
                    dataset[i].color = this.options.colors[i];
                }

                _.first(dataset, 5).forEach((item) => {
                    item.selected = true;
                });
                this.changeLegend();
            }
        });
    }

    public changeLegend() {
        this.filteredDataset = _.where(this.dataset, { selected: true });
    }
}

angular.module('naut').component('analyticsChart', {
    template: require('./analyticsChart.html'),
    controller: AnalyticsChartComponent,
    controllerAs: 'vm',
    bindings: {
        dataset: '=',
        timeFormat: '=',
        tooltipFormat: '='
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/analytics/components/analyticsChart/analyticsChart.component.ts